<template>
  <div class="dropdown searchable-select" :class="{ 'is-active': isOpen }">
    <div class="dropdown-trigger">
      <div class="control">
        <input
          type="text"
          class="input"
          :placeholder="disabled ? disabledPlaceholder : placeholder"
          :disabled="disabled"
          v-model="search"
          @focus="onFocus"
          @blur="onBlur"
          @keyup="onKeyup"
        />
      </div>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a
          v-if="isLoading"
          class="dropdown-item has-text-grey"
        >Loading...</a>
        <a
          v-else-if="results.length === 0"
          class="dropdown-item has-text-grey"
        >No results</a>
        <a
          v-else
          v-for="item in results"
          :key="item[optionValue]"
          class="dropdown-item"
          @mousedown.prevent="select(item)"
        >
          {{ optionLabel(item) }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { httpInstance as http } from "@/plugins/http";

export default {
  name: "SearchableSelect",
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    extraParams: {
      type: Object,
      default: () => ({}),
    },
    labelKey: {
      type: String,
      default: "name",
    },
    optionValue: {
      type: String,
      default: "id",
    },
    placeholder: {
      type: String,
      default: "Type to search...",
    },
    disabledPlaceholder: {
      type: String,
      default: "Select the previous field first",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resultFilter: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      search: "",
      results: [],
      isLoading: false,
      isOpen: false,
      searchTimeout: null,
    };
  },
  methods: {
    optionLabel(item) {
      return item[this.labelKey];
    },
    onFocus() {
      if (this.disabled) return;
      this.isOpen = true;
      this.fetchResults();
    },
    onBlur() {
      setTimeout(() => {
        this.isOpen = false;
      }, 150);
    },
    onKeyup() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchResults();
      }, 500);
    },
    async fetchResults() {
      if (this.disabled) return;
      this.isLoading = true;
      try {
        const response = await http.get(this.endpoint, {
          params: { search: this.search, page: 1, size: 20, ...this.extraParams },
        });
        const data = response.data;
        this.results = (Array.isArray(data) ? data : data.data || []).filter(this.resultFilter);
      } catch (error) {
        console.error(`Error fetching ${this.endpoint}:`, error);
        this.results = [];
      } finally {
        this.isLoading = false;
      }
    },
    select(item) {
      this.search = this.optionLabel(item);
      this.isOpen = false;
      this.$emit("select", item);
    },
    reset() {
      this.search = "";
      this.results = [];
    },
  },
  watch: {
    extraParams: {
      deep: true,
      handler() {
        this.reset();
        this.$emit("select", null);
      },
    },
    disabled(newVal) {
      if (newVal) this.reset();
    },
  },
};
</script>

<style scoped>
.searchable-select {
  width: 100%;
}

.dropdown-trigger,
.dropdown-trigger .control,
.dropdown-trigger .input {
  width: 100%;
}

.dropdown-menu {
  width: 100%;
}
</style>
